import { render, staticRenderFns } from "./ProductCategoryOverview.vue?vue&type=template&id=c0e373d4&scoped=true&"
import script from "./ProductCategoryOverview.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryOverview.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategoryOverview.vue?vue&type=style&index=0&id=c0e373d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e373d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0e373d4')) {
      api.createRecord('c0e373d4', component.options)
    } else {
      api.reload('c0e373d4', component.options)
    }
    module.hot.accept("./ProductCategoryOverview.vue?vue&type=template&id=c0e373d4&scoped=true&", function () {
      api.rerender('c0e373d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/ProductCategoryOverview.vue"
export default component.exports